"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPointPolicy = void 0;
var LocationPointPolicy;
(function (LocationPointPolicy) {
    LocationPointPolicy[LocationPointPolicy["Loose"] = 0] = "Loose";
    LocationPointPolicy[LocationPointPolicy["Strict"] = 1] = "Strict";
})(LocationPointPolicy || (exports.LocationPointPolicy = LocationPointPolicy = {}));
//# sourceMappingURL=LocationPointPolicy.js.map